import React from 'react';

export default function Feature({ iconSrc, title, subTitle }) {
  return (
    <div className="bg-white p-6 md:p-10 transition-all duration-300 relative overflow-hidden group hover:bg-cream hover:-translate-y-0.5 hover:shadow-xl hover:z-10 h-full flex flex-col">
      <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-crimson scale-x-0 transition-transform duration-300 origin-left group-hover:scale-x-100 mt-auto"></div>
      <div className="w-12 h-12 bg-crimson/5 rounded-full flex items-center justify-center mb-4 md:mb-6 text-xl shrink-0 text-crimson p-2.5">
        <img src={iconSrc} alt="Icon" className="w-full h-full object-contain" />
      </div>
      <h3 className="font-serif text-xl font-medium text-charcoal mb-3 leading-snug">
        {title}
      </h3>
      <p className="text-[0.88rem] leading-[1.7] text-mid font-light m-0">
        {subTitle}
      </p>
    </div>
  );
}
